const ROUTE_NAMES = {
  BASE_ROUTE: "/",

  MAIN_ROUTES: {
    CMS: "/cms",
    DASHBOARD: "/users",
    ADD_USERS: "/add-users",
    CONGREGATIONS: "/congregations",
    privacy_policy: "/privacy-policy",
    term_condition: "/term-and-condition",
    ADD_CONGREGATIONS: "/add-congregations",
    Edit_CONGREGATIONS: "/edit-congregations",
    REQUESTED_CONGREGATION: "/request-congregation",
    REQUESTED_CONGREGATION_DETAILS: "/request-congregation-details",
  },
  FRONT_ROUTES: {
    ABOUT: "/about",
    HOWTO: "/howto",
    CONTACT: "/contact",
    Donate: "/donate",
    LOGIN: "/login",
    PRIVACY: "/privacy",
    TERMS: "/terms-of-use"
  },
};

export default ROUTE_NAMES;
